import { useState } from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider, Button, MenuItem, Select, Snackbar, Alert, FormControl, InputLabel } from '@mui/material';
import ChangePasswordDialog from '../components/common/ChangePasswordDialog';
import ChangePasscodeDialog from '../components/common/ChangePasscodeDialog';
import ChangeEndpointDialog from '../components/common/ChangeEndpointDialog';

const languages = ['English', 'Shona', 'French'];
const themes = ['System', 'Light', 'Dark'];

const Settings = () => {
  const [language, setLanguage] = useState('English');
  const [theme, setTheme] = useState('System');
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [changePasscodeOpen, setChangePasscodeOpen] = useState(false);
  const [changeEndpointOpen, setChangeEndpointOpen] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({ open: false, message: '', severity: 'success' });
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passcode, setPasscode] = useState('');
  const [confirmPasscode, setConfirmPasscode] = useState('');
  const [baseUrl, setBaseUrl] = useState('https://tt.mifos.community/');
  const [tenant, setTenant] = useState('default');

  const handleChangePassword = () => {
    if (!password || password !== confirmPassword) {
      setSnackbar({ open: true, message: 'Passwords do not match.', severity: 'error' });
      return;
    }
    setSnackbar({ open: true, message: 'Password changed successfully.', severity: 'success' });
    setChangePasswordOpen(false);
    setPassword('');
    setConfirmPassword('');
  };

  const handleChangePasscode = () => {
    if (!passcode || passcode !== confirmPasscode) {
      setSnackbar({ open: true, message: 'Passcodes do not match.', severity: 'error' });
      return;
    }
    setSnackbar({ open: true, message: 'Passcode changed successfully.', severity: 'success' });
    setChangePasscodeOpen(false);
    setPasscode('');
    setConfirmPasscode('');
  };

  const handleChangeEndpoint = () => {
    if (!baseUrl || !tenant) {
      setSnackbar({ open: true, message: 'Base URL and Tenant are required.', severity: 'error' });
      return;
    }
    setSnackbar({ open: true, message: 'Endpoint updated successfully.', severity: 'success' });
    setChangeEndpointOpen(false);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: 'auto' }}>
      <Typography variant="h4" mb={2}>Settings</Typography>
      <Card>
        <CardContent>
          <List>
            <ListItem>
              <FormControl fullWidth>
                <InputLabel>Language</InputLabel>
                <Select
                  value={language}
                  label="Language"
                  onChange={e => setLanguage(e.target.value)}
                >
                  {languages.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
                </Select>
              </FormControl>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <FormControl fullWidth>
                <InputLabel>Theme</InputLabel>
                <Select
                  value={theme}
                  label="Theme"
                  onChange={e => setTheme(e.target.value)}
                >
                  {themes.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                </Select>
              </FormControl>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Button variant="outlined" onClick={() => setChangePasswordOpen(true)} fullWidth>
                Change Password
              </Button>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Button variant="outlined" onClick={() => setChangePasscodeOpen(true)} fullWidth>
                Change Passcode
              </Button>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Button variant="outlined" onClick={() => setChangeEndpointOpen(true)} fullWidth>
                Change Endpoint
              </Button>
            </ListItem>
          </List>
        </CardContent>
      </Card>
      
      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
        onSave={handleChangePassword}
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
      />
      
      <ChangePasscodeDialog
        open={changePasscodeOpen}
        onClose={() => setChangePasscodeOpen(false)}
        onSave={handleChangePasscode}
        passcode={passcode}
        setPasscode={setPasscode}
        confirmPasscode={confirmPasscode}
        setConfirmPasscode={setConfirmPasscode}
      />
      
      <ChangeEndpointDialog
        open={changeEndpointOpen}
        onClose={() => setChangeEndpointOpen(false)}
        onSave={handleChangeEndpoint}
        baseUrl={baseUrl}
        setBaseUrl={setBaseUrl}
        tenant={tenant}
        setTenant={setTenant}
      />
      
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Settings; 